// TODO: Hide user inputs that are related to unselected products
$(() => {
  const toggle_dependencies = () => {
    const fade = 400;

    const contract = $('#product-contract-checkbox');
    const compliance = $('#product-compliance-checkbox');

    const dependencies = [
      { element: $('#no-of-contracts-wrapper'), checkboxes: [contract] },
      { element: $('#net-patient-revenue-wrapper'), checkboxes: [compliance] },
      { element: $('#number-of-employees-wrapper'), checkboxes: [compliance] },
      { element: $('#fte-managing-compliance-docs-wrapper'), checkboxes: [compliance] },
      { element: $('#time-managing-compliance-docs-wrapper'), checkboxes: [compliance] },
      { element: $('#fte-managing-contract-docs-wrapper'), checkboxes: [contract] },
      { element: $('#time-managing-contract-docs-wrapper'), checkboxes: [contract] },
      { element: $('#time-on-contract-reporting-wrapper'), checkboxes: [contract] },
      { element: $('#time-on-compliance-reporting-wrapper'), checkboxes: [compliance] },
      { element: $('#assumed-impact-of-reputational-dmg-wrapper'), checkboxes: [compliance] },
      { element: $('#avg-operating-margin-wrapper'), checkboxes: [compliance] },
      { element: $('#avg-cost-of-external-assessment-wrapper'), checkboxes: [compliance] },
      { element: $('#time-tracking-issues-wrapper'), checkboxes: [compliance] },
      { element: $('#annual-contract-mgr-salary-wrapper'), checkboxes: [contract] },
      { element: $('#annual-compliance-mgr-salary-wrapper'), checkboxes: [compliance] },
      { element: $('.reduce-time-tracking-issues'), checkboxes: [compliance] },
      { element: $('.avoid-reputational-damage'), checkboxes: [compliance] },
      { element: $('.reduce-cost-of-external-assessments'), checkboxes: [compliance] },
      { element: $('.contract-benefit-impact-statment'), checkboxes: [contract] },
      { element: $('.percent-reduction-in-time-managing-docs-contract-statement'), checkboxes: [contract] },
      { element: $('.compliance-benefit-impact-statment'), checkboxes: [compliance] },
      { element: $('.percent-reduction-in-time-managing-docs-compliance-statement'), checkboxes: [compliance] },
      { element: $('.percent-reduction-in-time-reporting-compliance-statement'), checkboxes: [compliance] },
      { element: $('.percent-reduction-in-time-reporting-contract-statement'), checkboxes: [contract] },
      { element: $('#contract-implementation-fee-wrapper'), checkboxes: [contract] },
      { element: $('#contract-license-fee-wrapper'), checkboxes: [contract] },
      { element: $('#compliance-implementation-fee-wrapper'), checkboxes: [compliance] },
      { element: $('#compliance-license-fee-wrapper'), checkboxes: [compliance] },
      { element: $('.benefit-detail-contract'), checkboxes: [contract] },
      { element: $('.benefit-detail-compliance'), checkboxes: [compliance] },
    ];

    dependencies.forEach((dependency) => {
      const checked = dependency.checkboxes.filter(($checkbox) => $checkbox.is(':checked'));

      if (checked.length > 0) {
        dependency.element.slideDown(fade);
      } else {
        dependency.element.slideUp(fade);
      }
    });

    if (contract.is(':checked') === false || compliance.is(':checked') === false) {
      $('.product-benefit-separator').slideUp()
    } else {
      $('.product-benefit-separator').slideDown()
    }
  };

  // Define these changes separately because we only want them to fire when product options
  // are clicked. We don't want them firing on every pageload.
  const set_impact_variables = () => {
    let benefit_4_impact = 0;

    if ($('#product-contract-checkbox').is(':checked')) {
      benefit_4_impact += 40;
    }

    if ($('#product-compliance-checkbox').is(':checked')) {
      benefit_4_impact += 10;
    }

    $('#percent-reduction-in-prob-penalty').val(benefit_4_impact);
  };

  $('.product-options').click(() => {
    toggle_dependencies();
    set_impact_variables();
  });

  toggle_dependencies();
});
